/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_AgbInputs */

const de_commons_footer_agb = /** @type {(inputs: Commons_Footer_AgbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AGB`)
};

/** @type {(inputs: Commons_Footer_AgbInputs) => LocalizedString} */
const en_commons_footer_agb = de_commons_footer_agb;

/**

* @param {Commons_Footer_AgbInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_agb = /** @type {((inputs?: Commons_Footer_AgbInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_AgbInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_agb(inputs)
	return en_commons_footer_agb(inputs)
});